import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareBoardsRedirectRoute: InvariantJiraRoute = {
	name: 'project-settings-software-boards-redirect',
	path: '/jira/software/projects/:projectKey/settings/boards/:boardId',
	exact: true,
};
